import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class RestaurantService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    // Upload banner
    getbannerimage() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/list`).pipe(map(user => user));
    }

    uploadBannerImage(image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateBannerImage(id: any, image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/update/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    deleteBannerImage(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/delete/` + id).pipe(map(user => {
            return user;
        }));
    }


    // Menu Management

    // Variants
    addVariant(name: any) {
        var formData = {
            'name': name,
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    upadetVariant(id: any, name: any) {
        var formData = {
            'name': name,
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockedVariant(
        id: any,
        status: any,
    ) {
        var formData = {
            status: status,
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    getVariantById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/getById/${id}`).pipe(map(user => user));
    }
    deleteVariant(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getVariantList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getVariantDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/dropdown?status=` + status).pipe(map(user => user));
    }

    // category

    addcategory(payload: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/add`, payload).pipe(map(user => {
            return user;
        }));
    }

    updateCategory(id: any, payload: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/update/${id}`, payload).pipe(map(user => {
            return user;
        }));
    }
    blockedCategory(
        id: any,
        status: any,
    ) {
        var formData = {
            status: status,
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/category/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    getCategoryById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/getById/${id}`).pipe(map(user => user));
    }
    deleteCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getCategoryList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getCategoryDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/dropdown?status=` + status).pipe(map(user => user));
    }

    //   addons
    addAddons(name: any,
        status: any,
        showPrice: any,
        showAttribute: any,
        limit_type: any,
        min: any,
        max: any,
        values: any) {
        var formData = {
            name: name,
            limitType: limit_type,
            min: min,
            max: max,
            status: status,
            showPrice: showPrice,
            showAttribute: showAttribute,
            value: values,
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateAddons(id: any,
        name: any,
        status: any,
        showPrice: any,
        showAttribute: any,
        limit_type: any,
        min: any,
        max: any,
        values: any) {
        var formData = {
            name: name,
            limitType: limit_type,
            min: min,
            max: max,
            status: status,
            showPrice: showPrice,
            showAttribute: showAttribute,
            value: values,
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blockedAddons(
        id: any,
        status: any,
    ) {
        var formData = {
            status: status,
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    getAddonsById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/getById/${id}`).pipe(map(user => user));
    }
    deleteAddons(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getAddonsList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getAddonsDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/addon/dropdown?status=` + status).pipe(map(user => user));
    }

    // Food Item
    getMenuItems(page: any, search: any, status: any, categoryId: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/list?page=` +
                page +
                "&search=" +
                search +
                "&status=" +
                status +
                "&categoryId=" +
                categoryId
            )
            .pipe(map((user) => user));
    }

    getMenusById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/getById/${id}`).pipe(map(user => user));
    }

    deleteMenu(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    createItem(
        name: any,
        status: any,
        attribute: any,
        description: any,
        categories: any,
        variants: any,
        addOns: any,
        item_price: any,
        customisable: any,
        variant_yes: any,
        variant_no: any,
        addon_yes: any,
        addon_no: any,
        image: any
    ) {
        const formData = new FormData();

        formData.append('name', name);
        formData.append('attribute', attribute);
        formData.append('description', description);
        formData.append('status', status);
        formData.append('price', item_price);

        formData.append('customisable', String(customisable));
        formData.append('variants_yes', String(variant_yes));
        formData.append('variants_no', String(variant_no));
        formData.append('addOns_yes', String(addon_yes));
        formData.append('addOns_no', String(addon_no));
        formData.append('categories', JSON.stringify(categories))
        formData.append('variants', JSON.stringify(variants));
        formData.append('addOns', JSON.stringify(addOns));
        if (image) {
            if (image instanceof File) {
                formData.append('image', image, image.name);
            } else if (typeof image === 'string') {
                formData.append('image', image);
            }
        }
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateItem(
        id: any,
        name: any,
        status: any,
        attribute: any,
        description: any,
        categories: any,
        variants: any,
        addOns: any,
        item_price: any,
        customisable: any,
        variant_yes: any,
        variant_no: any,
        addon_yes: any,
        addon_no: any,
        image: any
    ) {
        // var formData = {
        //     name: name,
        //     attribute: attribute,
        //     description: description,
        //     status: status,
        //     categories: categories,
        //     variants: variants,
        //     addOns: addOns,
        //     price: item_price,
        //     customisable: customisable,
        //     variants_yes: variant_yes,
        //     variants_no: variant_no,
        //     addOns_yes: addon_yes,
        //     addOns_no: addon_no,
        // };
        const formData = new FormData();

        formData.append('name', name);
        formData.append('attribute', attribute);
        formData.append('description', description);
        formData.append('status', status);
        formData.append('price', item_price);

        formData.append('customisable', String(customisable));
        formData.append('variants_yes', String(variant_yes));
        formData.append('variants_no', String(variant_no));
        formData.append('addOns_yes', String(addon_yes));
        formData.append('addOns_no', String(addon_no));
        formData.append('categories', JSON.stringify(categories))
        formData.append('variants', JSON.stringify(variants));
        formData.append('addOns', JSON.stringify(addOns));
        if (image) {
            if (image instanceof File) {
                formData.append('image', image, image.name);
            } else if (typeof image === 'string') {
                formData.append('image', image);
            }
        }
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    getFoodItemDropdown(categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/dropdown?categoryId=` + categoryId).pipe(map(user => user));
    }

    blockedItem(
        id: any,
        status: any,
    ) {
        var formData = {
            status: status,
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/update/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getAllMenuImages(search: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/list-images?search=` +
                search
            )
            .pipe(map((user) => user));
    }
    uploadImage(id: any, image: any, catalogimage: any) {
        const formData: FormData = new FormData();
        var type: any;
        if (image) {
            formData.append("image", image, image.name);
            type = "image";
        } else {
            formData.append("image", catalogimage);
            type = "url";
        }
        return this.http
            .patch<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/uploadmenuimage/` +
                id +
                "?uploadType=" +
                type,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    // Get permission - Staff
    getStaffUsers(page: any, search: any, status: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/list?page=` +
                page +
                "&search=" +
                search +
                "&status=" +
                status
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    createStaff(formData: FormData) {
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteStaffUser(id: any) {
        return this.http
            .delete<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/delete/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    viewStaffUsersbyId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/viewById/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updatepassword(id: any, newPassword: any, confirmPassword: any) {
        const formData = {
            newPassword: newPassword,
            confirmPassword: confirmPassword
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/update-password/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateStaff(staffId: any, formData: FormData) {
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/update/${staffId}`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    blockStaffUser(id: any, name: any, username: any, status: any) {
        let formData =
        {
            name: name,
            username: username,
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    // Excel
    addonExcelUpload(file: any, restaurantId: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/addOnsUpload?restaurantId=` +
                restaurantId, formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadAddonExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/addOnsExcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    categopryExcelUpload(file: any, restaurantId: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/categoryUpload?restaurantId=` + restaurantId, formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadcategoryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/categoryexcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    foodItemExcelUpload(file: any, restaurantId: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/menuUpload?restaurantId=` + restaurantId,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadFoodItemExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/menuExceldownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    variantExcelUpload(file: any, restaurantId: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/variantUpload?restaurantId=`
                + restaurantId, formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadvariantExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/variantExcelDownload`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // Food Order
    orderDetails(orderStatus: any, search: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/list?orderStatus=` + orderStatus + '&search=' + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }

    ordeRDetails(orderStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/list?orderStatus=` + orderStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
    }
    updateOrderStatus(id: any, orderStatus: any, rejectedReason: any) {
        var formData = {
            'orderStatus': orderStatus,
            'rejectedReason': rejectedReason
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    settelmentDetails(paidStatus: any, search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any, driverId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settlement/list?paidStatus=` + paidStatus + '&search_invoiceNumber=' + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate + '&driverId=' + driverId).pipe(map(user => user));
    }

    paidUpdate(id: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settlement/settlement/${id}`, {});
    }

    getDriverDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/staff/dropdown?isDriver=` + 1).pipe(map(user => user));
    }

    getNewDeliveryCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/count`
            )
            .pipe(map((user) => user));
    }
    // Kanban board — active orders (new/accepted/pickedUp/delivered) grouped
    // by orderStatus in one call, keyed "0"/"1"/"3"/"4".
    getActiveGroupedOrders(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/active-grouped`).pipe(map(user => user));
    }

    getOrderDetailsByID(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/viewById/${id}`).pipe(map(user => user));
    }
    updateFoodOrderStatus(id: any, orderStatus: any, deliveryDate: any, deliveryTime: any
    ) {
        var formData = {
            'orderStatus': orderStatus,
            'deliveryDate': deliveryDate,
            'deliveryTime': deliveryTime
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/update-status/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    getDriverList(): Observable<any> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/list`);
    }

    assignSingleDriver(orderId: string, driverId: string, acceptedStatus: number): Observable<any> {
        const payload = {
            order_id: orderId,
            driver_id: driverId,
            accepted_status: acceptedStatus
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/update-accepted-status`, payload);
    }

    assignAllDrivers(orderId: string, driverIds: string[]): Observable<any> {
        const payload = {
            order_id: orderId,
            assigned_driver: driverIds
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/assign-drivers`, payload);
    }

    updateOrderStatusOnly(orderId: string, orderStatus: number, deliveryDate: any, deliveryTime: any): Observable<any> {
        const payload = {
            orderStatus: orderStatus,
            deliveryDate: deliveryDate,
            deliveryTime: deliveryTime
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/update-status/${orderId}`, payload);
    }

    assignAndAccept(orderId: string,driver_id: any,accepted_status: any): Observable<any> {
        const payload = {
            order_id: orderId,
         
            driver_id: driver_id,
            accepted_status: accepted_status
        };
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/order/update-accepted-status`, payload);
    }
    // Report
    FoodReportgenerationLists(page: any, search: any, startDate: any, endDate: any, categoryId: any, itemId: any, sold: any = '') {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/restaurant/list?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&categoryId=" +
                categoryId +
                "&itemId=" +
                itemId +
                "&sold=" +
                sold
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadFoodGenerationExcel(startDate: any, endDate: any, categoryId: any, itemId: any, sold: any = '') {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/restaurant/download?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                "&categoryId="
                + categoryId +
                "&itemId="
                + itemId +
                "&sold="
                + sold,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    downloadDeliveryExcel(startDate: any, endDate: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/downloadDeliveredOrder?startDate=` +
                startDate +
                "&endDate=" +
                endDate,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    // Status Change
    foodstatusChange(status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/statusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }

    // Weekly Timings
    getWeeklyTimings() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/operating-timings`).pipe(map(res => res));
    }

    saveWeeklyTimings(payload: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/operating-timings`, payload).pipe(map(res => res));
    }

    updateWeeklyTimings(payload: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/operating-timings`, payload).pipe(map(res => res));
    }

    downloadFooddeliveryExeclFormat(fromDate: any, toDate: any, search: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/restaurant/excel/downloadDeliveredOrder?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&search="
                + search,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // Coupon
    createRestaurantCoupon(formData: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/create`, formData).pipe(map(user => user));
    }

    getRestaurantCouponList(page: any, search: any, status: any, from: string = '', to: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/list?page=${page}&search=${search}&status=${status}&from=${from}&to=${to}`).pipe(map(user => user));
    }

    getRestaurantCouponById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/getById/${id}`).pipe(map(user => user));
    }

    updateRestaurantCoupon(id: any, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    deleteRestaurantCoupon(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/delete/${id}`).pipe(map(user => user));
    }

    updateRestaurantCouponStatus(id: any, status: any) {
        const formData = { status };
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    downloadRestaurantCouponUsageReport(from: string, to: string, search: any, status: any) {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/usage-report?from=${from}&to=${to}&search=${search}&status=${status}`, { responseType: 'blob' });
    }

    getVendorSettlementList(page: number, limit: number, fromDate: string, toDate: string, vendorType: string, vendorId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&vendorType=${vendorType}&vendorId=${vendorId}`).pipe(map(user => user));
    }

    getVendorSettlementDetail(vendorType: string, vendorId: string, fromDate: string, toDate: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/detail/${vendorType}/${vendorId}?fromDate=${fromDate}&toDate=${toDate}`).pipe(map(user => user));
    }

    // "How It's Calculated" sheet shared by the restaurant / laundry / club settlement pages.
    // data: { title, intro, rates, sections: [{ key, title, type: definitions | formulas | steps | table | bullets, ... }] }
    getSettlementFormulaSheet() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/formula-sheet`).pipe(map(user => user));
    }
}